import { StoreReducer } from "@grassrootly/rn-core";
import AuthReducer from "./auth/AuthReducer";
import GameReducer from "./game/GameReducer";
import StatsReducer from './stats/StatsReducer';
import GroupsReducer from './groups/GroupsReducer';

const APIReducers: { [key: string]: StoreReducer } = {
  auth: AuthReducer,
  games: GameReducer,
  stats: StatsReducer,
  groups: GroupsReducer
};

export default APIReducers;
